class LangService {
    shop = "meine-landausfluege.de";
    lang = "en";
    widget = "widget";
    apiSelected = "api";
    protocol = window.location.protocol;

    constructor() {
        let hostname = window.location.hostname,
            i = hostname.indexOf('.');

        this.widget = hostname.slice(0, i).trim();
        this.apiSelected = this.widget === 'devwidget' ? 'devapi' : 'api';
        this.shop = hostname.slice(i + 1, hostname.length).trim();

        if (this.shop === 'mycruiseexcursion.com' || this.shop === 'mycruiseexcursion.co.uk') {
            this.lang = 'en';
        } else if (this.shop === 'meine-landausfluege.de' || this.shop === 'meine-landausfluege.ch') {
            this.lang = 'ge';
        }
    }

    setShop(data) {
        this.shop = data;
    }

    getLang() {
        return this.lang;
    }

    getShop() {
        return this.shop;
    }

    getUrlWidget() {
        if (process.env.VUE_APP_WIDGET_URL){
            return process.env.VUE_APP_WIDGET_URL
        }
        return this.protocol + '//' + this.widget + '.' + this.shop;
    }

    getUrlApi() {
        if (process.env.VUE_APP_API_URL){
            return process.env.VUE_APP_API_URL;
        }
        return this.protocol + '//' + this.apiSelected + '.' + this.shop;
    }

}

export default new LangService();
